


































































































import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import { ValueTypeDefinition } from "@/api/model/FactorResource";
import moment from "moment";
import { Storage } from "aws-amplify";
import _ from "lodash";


@Component({
    components: {}
})
export default class FactorValueDisplay extends Vue {

    @Prop()
    value!: any;

    @Prop()
    textAlign!: string;

    @Prop()
    valueTypeDefinition!: ValueTypeDefinition;

    @Prop({ default: false, type: Boolean })
    disableInput!: boolean;

    private filePath: any = null;

    get valueType() {
        if (this.valueTypeDefinition) return this.valueTypeDefinition.valueType;
    }

    get valueSubType() {
        if (this.valueTypeDefinition) return this.valueTypeDefinition.valueSubType;
    }

    get valuePrefix() {
        if (this.valueTypeDefinition) return this.valueTypeDefinition.valuePrefix;
    }

    get valueSuffix() {
        if (this.valueTypeDefinition) return this.valueTypeDefinition.valueSuffix;
    }

    get categoricalValues() {
        if (this.valueTypeDefinition) return this.valueTypeDefinition.categoricalValues;
    }

    get cdnPath() {
        if (this.valueType === 'FILE' && this.value) {
            return `${process.env.VUE_APP_CHOICE_CDN}/${this.value}`;
        }
    }

    get formattedText(): string {
        let text = '';
        if (this.valuePrefix) {
            text += this.valuePrefix + ' ';
        }
        if (this.value) {
            if (this.valueType === 'DATE_TIME') {
                text += moment(this.value).format(this.valueTypeDefinition.format)
            } else {
                text += this.value;
            }
        }
        if (this.valueSuffix) {
            text += ' ' + this.valueSuffix;
        }
        if (this.valueType === 'TEXT' && this.valueTypeDefinition.format === 'HTML') {
           return _.unescape(text)
        }
        return text;
    }

    private getFileText(dataValue: string) {
        if (dataValue) {
            let splits = dataValue.split('/')
            let fileName = splits[splits.length - 1]
            let lastIndexOfParams = fileName.lastIndexOf('?');
            if (lastIndexOfParams > 0) {
                return fileName.split('?')[0]
            }
            return fileName;
        }
        return '';
    }

    private async getFilePath() {
        if (this.valueTypeDefinition.valueType && this.valueTypeDefinition.valueType == 'FILE' ) {
            this.filePath = await Storage.get(this.value);
        }
    }

    private getTextAlign(value: any): string {
        let res: string = 'text-left';
        // TODO - Remove function after some User Testing (Dion - 2020-09-26)
        //
        // const length: number = String(value).length;
        // if (length < 20) {
        //     res = 'text-center';
        // }
        return res;
    }

    mounted() {
        this.getFilePath();
    }
}
